var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dg-menu", attrs: { id: "DgMenu" } },
    [
      !_vm.collapse
        ? _c("h4", { style: _vm.titleStyle, attrs: { id: "test" } }, [
            _vm._v(_vm._s(_vm.prodtitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          attrs: {
            "background-color": _vm.backgroundColor,
            "text-color": _vm.textColor,
            "default-active": _vm.activeIndex,
            collapse: _vm.collapse,
          },
          on: {
            select: _vm.handleSelect,
            open: _vm.handleOpenClose,
            close: _vm.handleOpenClose,
          },
        },
        [
          _vm._l(_vm.menuList, function (list) {
            return [
              _c("dg-sub-menu", {
                key: list[_vm.keyField],
                attrs: {
                  list: list,
                  "key-field": _vm.keyField,
                  "pkey-field": _vm.pkeyField,
                  "title-field": _vm.titleField,
                  "route-field": _vm.routeField,
                },
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }